import _slicedToArray from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState as u, useEffect as s, useCallback as g } from "react";

var m = function m(e) {
  var _u = u(null),
      _u2 = _slicedToArray(_u, 2),
      o = _u2[0],
      r = _u2[1],
      t = g(function () {
    if (e) {
      var n = e.querySelector(".hg-primarynav__flyout-content");

      if (n instanceof HTMLElement) {
        var i = n.getBoundingClientRect().height,
            l = parseInt(window.getComputedStyle(e).getPropertyValue("--primarynav-height"));
        r(Math.ceil(i + l));
      }
    }
  }, [e]);

  return s(function () {
    return t(), window.addEventListener("resize", t), function () {
      window.removeEventListener("resize", t);
    };
  }, [e, t]), o;
};

export { m as useFlyoutHeight };